export const SALE_PROCESS_MODULE_NAME = "saleProcess";

// TODO: simplify when module namespaced
export const SALE_PROCESS_CLEAR_STATE = "clearSaleProcessState";

// TODO: simplify when module namespaced
export const SALE_PROCESS_CLEAR_ACTION = "clearSaleProcessAction";

export const SaleProcessStoreActions = {
	CLEAR: `${SALE_PROCESS_CLEAR_ACTION}`
} as const;
